
<template>

<div class="grid">
    <el-card class="box-card card">
       <h2 style="margin:0;" id="toc_7">更新设备信息</h2>

          <p class="md_block">
              <span class="md_line">请求地址:</span>
          </p>


          <pre><code>https://box.takefit.cn/run/Saas/setBox</code></pre>

            <p class="md_block">
                <span class="md_line">请求方法:<code>POST</code></span>
            </p>


            <p class="md_block">
                <span class="md_line">请求参数:</span>
            </p>


<pre><code>{
    service_id:00xxxx01
    service_key:KMPYxxxx-xxxx-xxxx-xxxxQ4JZ
    sn:90xx01
    venue_uuid:string    //（选填，请保证唯一）
    venue_area_uuid:string    //（选填，请保证唯一）
    bg_url:string    //(选填）
    logo_url:string    //（选填）
    show_title:string    //（选填）
}</code></pre>

            <!--block_code_end-->
            <p class="md_block">
                <span class="md_line">返回结果:</span>
            </p>


<pre><code>正确返回
    
{
    "rst": 0,
    "msg": "云操作设置成功",
    "data": 1    //成功设置盒子数量
}
</code></pre>

            <!--block_code_end-->
<pre><code>错误返回

{
    "rst": 10000,
    "msg": "云操作参数错误"
}

或

{
    "rst": 1,
    "msg": "云操作厂商尚未授权"
}

或

{
    "rst": 1,
    "msg": "云操作盒子不存在"
}

或

{
    "rst": 1,
    "msg": "云操作设置失败或没有数据被修改"
}
</code></pre>
    </el-card>
</div>

</template>

<script>

export default {
  data() {
    return {
        msg: 'Help',
    }
  }
};

</script>
<style lang="css" scoped>

::-webkit-scrollbar {
    width: 8px;
    margin: 0 1px;
    background: #fdfdfd;
}

::-webkit-scrollbar:horizontal {
    height: 8px;
}

::-webkit-scrollbar-button {
    height: 0;
}

::-webkit-scrollbar-track {
    border-radius: 4px;
}

::-webkit-scrollbar-track-piece {
    background-color: #fdfdfd;
    border-radius: 4px;
}

::-webkit-scrollbar-thumb {
    width: 8px;
    margin: 0 1px;
    border-radius: 4px;
    background: #c4c4c4;
}

::-webkit-scrollbar-thumb:hover {
    background: #909090;
}

body {
    background: #ffffff;
    font-size: 14px;
    line-height: 2.1025;
    font-family: "Menlo", "Andale Mono", monospace, "Droid Sans Fallback", "Microsoft YaHei", sans-serif;
    font-weight: normal;
    color: #3c3c3c;
    padding: 0 38px;
    max-width: 820px;
    margin: 0 auto;
    word-wrap: break-word;
    overflow-x: hidden;
    text-rendering: optimizeLegibility;
    -webkit-text-size-adjust: none;
}

br {
    line-height: 2.1025;
}
@media (max-width: 600px) {
    body {
        padding: 0 30px;
    }
}

@media (max-width: 480px) {
    body {
        padding: 0 20px;
    }
}

.gist {
    word-break: normal;
}

.post {
    margin-top: 10px;
    margin-bottom: 50px;
    position: relative;
}

img {
    max-width: 98%;
    margin: 0.8em auto 0.8em auto;
    border-radius: 5px;
}

h1 img,
h2 img,
h3 img,
h4 img,
h5 img,
h6 img {
    margin: auto;
}

.x2_image {
    zoom: 50%;
}

.x3_image {
    zoom: 33.33%;
}

.x4_image {
    zoom: 25%;
}

p img {
    margin: 0 auto;
}

p {
    word-wrap: break-word;
    overflow: hidden;
    margin: 1.5em 0 0.5em 0;
}

li p {
    line-height: 1.885;
    margin: 0;
}

.p_part {
    margin: 10px 0;
}

.p_part p {
    margin: 0 0 0.6em 0;
}


/* text indent for chinese starts*/


/*h2, h3, h4, h5, h6, .p_part p, .todo_item, p{
        text-indent: 0px;
    }*/

table,
pre,
svg,
.codehilitetable {
    margin-left: 0px;
    margin-right: 0px;
}

.codehilitetable pre {
    margin-left: 0;
    margin-right: 0;
}

.codehilitetable .codehilite pre {
    border-left: none;
}


/* text indent for chinese ends*/

blockquote .p_part p,
li .p_part p {
    text-indent: 0 !important;
}

hr {
    margin: 38px 0;
    border: none;
    border-bottom: 1px dashed #e3e3e3;
    color: #e3e3e3;
    height: 1px;
    line-height: 1px;
    font-size: 1px;
    overflow: hidden;
}

h1 {
    color: #10a3ee;
    font-size: 1.7em;
    text-align: left;
    margin: 0;
    padding: 0;
    line-height: 1.6em;
    margin-top: 0;
    margin-bottom: 0.6em;
}

h1,
h2,
h3,
h4 {
    color: #10a3ee;
}

h1,
h2,
h3 {
    font-weight: normal;
}

h2,
h3 {
    line-height: 1.5em;
    margin-top: 1.5em;
    margin-bottom: 0.8em;
}

h2 {
    font-size: 1.45em;
}

h3 {
    font-size: 1.25em
}

ol {
    margin: 0;
}

ul {
    padding: 5px 38px;
    margin: 0;
}

ul li,
li {
    padding: 0;
    margin: 0;
}

ul p,
ol p {
    overflow: visible;
}

blockquote {
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    margin: 1.6em 0;
    padding: 0 0 0 1.2em;
    border-left: 0.4em solid #dddddd;
    color: #888888;
    min-height: 20px;
}

blockquote p {
    margin: 0.8em 0;
}

blockquote span.md_line {
    margin-bottom: 0.25em;
    margin-top: 0.25em;
}

blockquote ul {
    padding: 0 15px;
}

blockquote small {
    display: inline-block;
    margin: 0.8em 0 0.8em 1.5em;
    font-size: 0.9em;
    color: #ccc;
}

table {
    background-color: transparent;
    border-collapse: collapse;
    border-spacing: 0;
    border: 1px solid #d9d9d9;
    border-left: 0;
    margin-top: 20px;
    margin-bottom: 20px;
}

th,
td {
    border-left: 1px solid #d9d9d9;
    padding: 8px;
    line-height: 20px;
    text-align: left;
    vertical-align: top;
    border-top: 1px solid #d9d9d9;
}

code {
    background: #f5f5f5;
    padding: 0 5px;
    margin: 0 2px;
}

pre {
    border: 1px solid #e6e6e6;
    margin-top: 0;
    margin-bottom: 1.2em;
    padding: 15px 10px;
    display: block;
    overflow: auto;
    background: #f7f7f7;
    font-size: 90%;
}

.with_lines pre {
    border: none;
    margin-top: 0.2em;
    margin-bottom: 0.2em;
    background: transparent;
}

.is_code_file pre {
    border: none;
    background: transparent;
}

.codehilite pre {
    word-wrap: normal;
}

pre code {
    border: none;
    background: none;
    padding: 0;
    margin: 0;
}

pre p {
    margin: 0;
    padding: 0;
}

.codehilite th,
.codehilite td {
    line-height: 1.8em;
}

a {
    color: #4083c4;
    text-decoration: none;
    //border-bottom: 1px solid transparent;
}

a:hover {
    text-decoration: underline;
    //border-bottom: 1px solid #4083c4;
}

strong {
    color: #000000;
    font-weight: bold;
}


/* for markdown */

.linenos pre {
    background: transparent;
    border: none;
}


/*
    .linenos{
        padding: 0 0 0 10px;
    }
    */

.toc {
    background: #fdfdfd;
    border-radius: 5px;
    border: 1px solid #e6e6e6;
    margin: 27px 0 47px 0;
    padding: 10px 0;
}

.toc ul {
    //padding: 5px 42px;
}

.toc ul li {
    padding: 0;
    margin: 0;
}

.toc a {
    color: #3c3c3c;
}

.todo_item {
    list-style: none;
    margin-left: -1.5em
}

.todo_item .todo_item {
    margin-left: auto;
}

.todo_done_item {
    color: #999999;
}

.todo_undone_item {
    color: #c85a57;
}

ul li.todo_item {
    list-style-type: none;
}

ul li.todo_item:before {
    content: '\2715';
    padding-right: 0.7em;
    font-family: arial;
}

ul li.todo_done_item:before {
    content: '\2713';
    padding-right: 0.7em;
    font-family: arial;
}

ul li.todo_item input {
    display: none
}


/*pygments*/

.codehilite {
    background: transparent !important;
}

table.codehilitetable {
    border: none;
}

.codehilitetable td {
    border: none;
    padding: 0;
}

.flow-graphic {
    text-align: center
}

table,
tr,
td,
th,
tbody,
thead,
tfoot,
.md_echarts,
blockquote .md_line {
    page-break-inside: avoid !important;
}

.footnotes .md_line {
    display: inline !important;
}

.img_rt_90 {
    transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    -o-transform: rotate(90deg);
}

.img_rt_180 {
    transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    -o-transform: rotate(180deg);
}

.img_rt_270 {
    transform: rotate(270deg);
    -ms-transform: rotate(270deg);
    -moz-transform: rotate(270deg);
    -webkit-transform: rotate(270deg);
    -o-transform: rotate(270deg);
}

.md_has_block_below {
    margin-bottom: 0.1em !important;
}

.md_has_block_below_img {
    margin-bottom: -0.6em !important;
}

span.md_line {
    margin-top: 0.5em;
    display: block;
    line-height: 1.8186625
}

.md_line br {
    display: none;
}

.codehilite .hll {
    background-color: #ffffcc
}

.codehilite {
    background: #eeeedd;
}

.codehilite .c {
    color: #999999
}


/* Comment */

.codehilite .err {
    color: #a61717;
    background-color: #e3d2d2
}


/* Error */

.codehilite .k {
    color: #8B008B;
    font-weight: bold
}


/* Keyword */

.codehilite .n {
    color: #555555
}


/* Name */

.codehilite .o {
    color: #555555
}


/* Operator */

.codehilite .p {
    color: #555555
}


/* Punctuation */

.codehilite .cm {
    color: #999999
}


/* Comment.Multiline */

.codehilite .cp {
    color: #1e889b
}


/* Comment.Preproc */

.codehilite .c1 {
    color: #999999
}


/* Comment.Single */

.codehilite .cs {
    color: #8B008B;
    font-weight: bold
}


/* Comment.Special */

.codehilite .gd {
    color: #aa0000
}


/* Generic.Deleted */

.codehilite .ge {
    font-style: italic
}


/* Generic.Emph */

.codehilite .gr {
    color: #aa0000
}


/* Generic.Error */

.codehilite .gh {
    color: #000080;
    font-weight: bold
}


/* Generic.Heading */

.codehilite .gi {
    color: #00aa00
}


/* Generic.Inserted */

.codehilite .go {
    color: #888888
}


/* Generic.Output */

.codehilite .gp {
    color: #555555
}


/* Generic.Prompt */

.codehilite .gs {
    font-weight: bold
}


/* Generic.Strong */

.codehilite .gu {
    color: #800080;
    font-weight: bold
}


/* Generic.Subheading */

.codehilite .gt {
    color: #aa0000
}


/* Generic.Traceback */

.codehilite .kc {
    color: #8B008B;
    font-weight: bold
}


/* Keyword.Constant */

.codehilite .kd {
    color: #8B008B;
    font-weight: bold
}


/* Keyword.Declaration */

.codehilite .kn {
    color: #8B008B;
    font-weight: bold
}


/* Keyword.Namespace */

.codehilite .kp {
    color: #8B008B;
    font-weight: bold
}


/* Keyword.Pseudo */

.codehilite .kr {
    color: #8B008B;
    font-weight: bold
}


/* Keyword.Reserved */

.codehilite .kt {
    color: #a7a7a7;
    font-weight: bold
}


/* Keyword.Type */

.codehilite .m {
    color: #B452CD
}


/* Literal.Number */

.codehilite .s {
    color: #CD5555
}


/* Literal.String */

.codehilite .na {
    color: #658b00
}


/* Name.Attribute */

.codehilite .nb {
    color: #658b00
}


/* Name.Builtin */

.codehilite .nc {
    color: #008b45;
    font-weight: bold
}


/* Name.Class */

.codehilite .no {
    color: #00688B
}


/* Name.Constant */

.codehilite .nd {
    color: #707a7c
}


/* Name.Decorator */

.codehilite .ni {
    color: #555555
}


/* Name.Entity */

.codehilite .ne {
    color: #008b45;
    font-weight: bold
}


/* Name.Exception */

.codehilite .nf {
    color: #008b45
}


/* Name.Function */

.codehilite .nl {
    color: #555555
}


/* Name.Label */

.codehilite .nn {
    color: #008b45;
    text-decoration: underline
}


/* Name.Namespace */

.codehilite .nx {
    color: #555555
}


/* Name.Other */

.codehilite .py {
    color: #555555
}


/* Name.Property */

.codehilite .nt {
    color: #8B008B;
    font-weight: bold
}


/* Name.Tag */

.codehilite .nv {
    color: #00688B
}


/* Name.Variable */

.codehilite .ow {
    color: #8B008B
}


/* Operator.Word */

.codehilite .w {
    color: #bbbbbb
}


/* Text.Whitespace */

.codehilite .mb {
    color: #B452CD
}


/* Literal.Number.Bin */

.codehilite .mf {
    color: #B452CD
}


/* Literal.Number.Float */

.codehilite .mh {
    color: #B452CD
}


/* Literal.Number.Hex */

.codehilite .mi {
    color: #B452CD
}


/* Literal.Number.Integer */

.codehilite .mo {
    color: #B452CD
}


/* Literal.Number.Oct */

.codehilite .sb {
    color: #CD5555
}


/* Literal.String.Backtick */

.codehilite .sc {
    color: #CD5555
}


/* Literal.String.Char */

.codehilite .sd {
    color: #CD5555
}


/* Literal.String.Doc */

.codehilite .s2 {
    color: #CD5555
}


/* Literal.String.Double */

.codehilite .se {
    color: #CD5555
}


/* Literal.String.Escape */

.codehilite .sh {
    color: #1c7e71;
    font-style: italic
}


/* Literal.String.Heredoc */

.codehilite .si {
    color: #CD5555
}


/* Literal.String.Interpol */

.codehilite .sx {
    color: #cb6c20
}


/* Literal.String.Other */

.codehilite .sr {
    color: #1c7e71
}


/* Literal.String.Regex */

.codehilite .s1 {
    color: #CD5555
}


/* Literal.String.Single */

.codehilite .ss {
    color: #CD5555
}


/* Literal.String.Symbol */

.codehilite .bp {
    color: #658b00
}


/* Name.Builtin.Pseudo */

.codehilite .vc {
    color: #00688B
}


/* Name.Variable.Class */

.codehilite .vg {
    color: #00688B
}


/* Name.Variable.Global */

.codehilite .vi {
    color: #00688B
}


/* Name.Variable.Instance */

.codehilite .il {
    color: #B452CD
}


/* Literal.Number.Integer.Long */

.tree{
    width: 15%;
    overflow: hidden;
    float: left;
    box-shadow: 0 1px 5px rgba(0,0,0,0.2);
    border-radius: 5px;
}

.card{
    width: 83%;
    min-height: 300px;
    margin-left: 1%;
    float: left;
}

</style>
